module.exports = __webpack_public_path__ + "img/heart.073312f7.svg";